export const APA_GUIDE_LINE_REQUEST = 'APA_GUIDE_LINE_REQUEST';
export const APA_GUIDE_LINE_SUCCESS = 'APA_GUIDE_LINE_SUCCESS';
export const APA_GUIDE_LINE_FAIL    = 'APA_GUIDE_LINE_FAIL';

